import type { Priority } from '@/types';

/** Three accepted time forms. Order matters — try most-specific first. */
export const TIME_REGEX_24H = /\b(\d{1,2}):(\d{2})\b/; // "14:00", "9:30"
export const TIME_REGEX_AMPM = /\b(\d{1,2})(?::(\d{2}))?\s*(am|pm)\b/i; // "2pm", "9:30am", "9am"
export const TIME_REGEX_NAMED = /\b(noon|midnight)\b/i; // 12:00 / 00:00
/** Optional "at " prefix that we strip before/after matching */
export const TIME_AT_PREFIX = /\bat\s+/i;

export const DURATION_REGEX =
  /\b(?:for\s+)?(\d+)\s*(minutes|minute|mins|min|hours|hour|hrs|hr|m|h)\b/i;

export const DATE_RELATIVE_REGEX = /\b(today|tomorrow|tmrw|tonight)\b/i;
export const DATE_RELATIVE_WEEK_REGEX = /\b(next week|this week)\b/i;
export const DATE_WEEKDAY_REGEX =
  /\b(monday|tuesday|wednesday|thursday|friday|saturday|sunday|mon|tue|wed|thu|fri|sat|sun)\b/i;
export const DATE_EXPLICIT_REGEX =
  /\b(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\s+(\d{1,2})\b/i;

export const PRIORITY_CRITICAL_REGEX = /\b(urgent|critical)\b/i;
export const PRIORITY_HIGH_REGEX = /\b(high)\b/i;
export const PRIORITY_LOW_REGEX = /\b(low)\b/i;
export const PRIORITY_MEDIUM_REGEX = /\b(medium|med)\b/i;
/** "!" at very start of input → high. ^ anchored. */
export const PRIORITY_BANG_REGEX = /^\s*!\s*/;

export const TAG_REGEX = /#[a-z0-9_-]+/gi;

/** Weekday name → 0-indexed day-of-week (Sunday=0). */
export const WEEKDAY_INDEX: Record<string, number> = {
  sun: 0,
  sunday: 0,
  mon: 1,
  monday: 1,
  tue: 2,
  tuesday: 2,
  wed: 3,
  wednesday: 3,
  thu: 4,
  thursday: 4,
  fri: 5,
  friday: 5,
  sat: 6,
  saturday: 6,
};

/** Month name → 0-indexed month (Jan=0). */
export const MONTH_INDEX: Record<string, number> = {
  jan: 0,
  feb: 1,
  mar: 2,
  apr: 3,
  may: 4,
  jun: 5,
  jul: 6,
  aug: 7,
  sep: 8,
  oct: 9,
  nov: 10,
  dec: 11,
};

/** Duration unit → minutes per unit. */
export const DURATION_UNIT_MIN: Record<string, number> = {
  m: 1,
  min: 1,
  mins: 1,
  minute: 1,
  minutes: 1,
  h: 60,
  hr: 60,
  hrs: 60,
  hour: 60,
  hours: 60,
};

/** Priority ranking — higher number wins when multiple priorities are parsed. */
export const PRIORITY_RANK: Record<Priority, number> = {
  low: 0,
  medium: 1,
  high: 2,
  critical: 3,
};
